import { classNames } from "repoV2/utils/common/render/classNames";
import React from "react";
import { PoweredByExly } from "repoV2/features/CreatorPages/modules/PoweredByExly";
import styles from "./detailsSectionFooter.module.scss";
import commonStyles from "../../commonStyles.module.scss";
import SslSection from "../../SslSection";

const DetailsSectionFooter = ({ isMobile }: { isMobile: boolean }) => {
    if (isMobile) return null;

    return (
        <div
            className={classNames(
                styles.container,
                commonStyles.detailsSectionsContainer,
                "d-flex justify-content-between align-items-center"
            )}
        >
            <div className={styles.footerText}>
                <PoweredByExly
                    exlyTextClass={classNames(styles.brand, styles.footerText)}
                    exlyClickDisabled={false}
                />
            </div>
            <SslSection />
        </div>
    );
};

export default DetailsSectionFooter;
